import { motion } from "framer-motion";

const STEPS = [
  { num: "01", title: "SEND YOUR FOOTAGE", desc: "Whatever clips you have — camera-roll chaos welcome. Phone footage is perfect." },
  { num: "02", title: "TELL ME THE VIBE", desc: "The feeling, the style, the references. Emotion matters more than technical notes." },
  { num: "03", title: "I BUILD THE STORY", desc: "Clip selection, pacing, music, captions when requested, sequencing, and the final export." },
  { num: "04", title: "YOU REVIEW IT", desc: "You watch it, react to it, and tell me what to adjust." },
  { num: "05", title: "READY TO POST", desc: "Final export delivered, sized for the platform it's going on." },
];

export const Process = () => (
  <section
    id="process"
    data-testid="process-section"
    className="bg-[#050505] px-5 py-24 sm:px-10 sm:py-36"
  >
    <div className="mx-auto max-w-7xl">
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        className="mb-8 block font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs"
      >
        04 — THE PROCESS
      </motion.span>

      <div className="border-t border-white/10">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.num}
            data-testid={`process-step-${s.num}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
            className="group grid grid-cols-[auto_1fr] items-baseline gap-6 border-b border-white/10 py-8 transition-colors duration-500 hover:bg-[#0D0D0F] sm:grid-cols-[120px_1fr_1fr] sm:gap-10 sm:py-10"
          >
            <span className="font-display text-4xl font-black leading-none text-[#3a3a3f] transition-colors duration-500 group-hover:text-[#E63946] sm:text-6xl">
              {s.num}
            </span>
            <h3 className="font-display text-2xl font-black uppercase tracking-tight text-[#F3F3F5] sm:text-4xl">
              {s.title}
            </h3>
            <p className="col-span-2 max-w-md text-sm leading-relaxed text-[#8E8E93] sm:col-span-1">
              {s.desc}
            </p>
          </motion.div>
        ))}
      </div>

      <p className="mt-10 max-w-xl text-sm text-[#8E8E93]">
        That's it. You send the footage, tell me the feeling, and I handle everything between
        your camera roll and the post button.
      </p>
    </div>
  </section>
);
